import { CheckCircle2, Clock3, UserCheck, XCircle, UserX, Flag } from 'lucide-react';
import { ReservationStatus } from '../../../../types/restaurant/RestaurantReservationTypes';

const config: Record<ReservationStatus, { label: string; className: string; icon: typeof Clock3 }> = {
  PENDING: { label: 'Pendiente', className: 'bg-warning/10 text-meta-8 border-warning/25', icon: Clock3 },
  CONFIRMED: { label: 'Confirmada', className: 'bg-primary/10 text-primary border-primary/20', icon: CheckCircle2 },
  SEATED: { label: 'Recibida', className: 'bg-meta-10/10 text-meta-10 border-meta-10/20', icon: UserCheck },
  COMPLETED: { label: 'Completada', className: 'bg-success/10 text-success border-success/20', icon: Flag },
  CANCELLED: { label: 'Cancelada', className: 'bg-danger/10 text-danger border-danger/20', icon: XCircle },
  NO_SHOW: { label: 'No se presentó', className: 'bg-body/10 text-body border-body/20', icon: UserX },
};

const ReservationStatusBadge = ({ status }: { status: ReservationStatus }) => {
  const item = config[status];
  const Icon = item.icon;
  return <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold ${item.className}`}><Icon className="h-3.5 w-3.5" />{item.label}</span>;
};

export default ReservationStatusBadge;

